import Constants from '../constants/Constants';
import ApiUtil from '../util/ApiUtil';
import {ICaptionData, ICaptionTrack, nullCaptionTrackFactory} from '../model/captionModels';

const baseUrl = '/api/v1/captions';

const getCaptionTrack = async (mediaId: string) => {
   const response = await ApiUtil.executeGetWithoutCacheAsync(`${baseUrl}/${mediaId}`, [Constants.statusCodes.ok]);
   return response.data as ICaptionTrack;
};

const getStatus = async (mediaId: string): Promise<ICaptionData[]> => {
   const response = await ApiUtil.executeGetWithoutCacheAsync(`${baseUrl}/${mediaId}/status`, [Constants.statusCodes.ok]);
   // eslint-disable-next-line @typescript-eslint/no-unsafe-return
   return Array.isArray(response.data) ? response.data : [response.data] as ICaptionData[];
};

const saveCaptionTrack = async (mediaId: string, captionTrack: ICaptionTrack) => await ApiUtil.executePutAsync(`${baseUrl}/${mediaId}`, [Constants.statusCodes.noContent], captionTrack);

const setAssignee = async (mediaId: string, emailAddress: string) => {
   const encodedEmail: string = encodeURIComponent(emailAddress);
   return await ApiUtil.executePutAsync(`${baseUrl}/${mediaId}/assign/${encodedEmail}`, [Constants.statusCodes.noContent]);
};

const removeAssignee = async (mediaId: string) => await ApiUtil.executeDeleteAsync(`${baseUrl}/${mediaId}/assign`, [Constants.statusCodes.noContent]);

const publishCaptionTrack = async (mediaId: string) => {
   const mediaCaptionTrack = await getCaptionTrack(mediaId);
   const putData = nullCaptionTrackFactory({captions: mediaCaptionTrack.captions});

   return await ApiUtil.executePutAsync(`${baseUrl}/${mediaId}/publish`, [Constants.statusCodes.noContent], putData);
};

const deleteCaptionTrack = async (mediaId: string) => {
   const emptyCaptionTrack = Object.assign({}, await getCaptionTrack(mediaId), {captions: []});

   await ApiUtil.executePutAsync(`${baseUrl}/${mediaId}/publish`, [Constants.statusCodes.noContent], emptyCaptionTrack);
};

export default {
   getCaptionTrack,
   getStatus,
   saveCaptionTrack,
   setAssignee,
   removeAssignee,
   publishCaptionTrack,
   deleteCaptionTrack
};
